import { motion } from "framer-motion";
import { CalendarDays, Clock, Video, Languages, Award, Users } from "lucide-react";

const details = [
  { icon: CalendarDays, label: "Début", value: "1er octobre 2026" },
  { icon: Clock, label: "Durée", value: "19 semaines · 3 h par semaine" },
  { icon: Video, label: "Format", value: "100 % à distance (visioconférence)" },
  { icon: Languages, label: "Langue", value: "Français" },
  { icon: Award, label: "Certification", value: "CPMC — reconnue à l'international" },
  { icon: Users, label: "Cohorte", value: "20 places maximum — première cohorte" },
];

export default function Details() {
  return (
    <section className="border-y border-ink/10 bg-mint/20 py-24 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="mb-12 font-mono text-xs uppercase tracking-[0.3em] text-teal-dark"
        >
          Détails pratiques
        </motion.p>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {details.map((d, i) => (
            <motion.div
              key={d.label}
              data-testid={`cpmc-detail-card-${i + 1}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="flex items-start gap-4 rounded-2xl border border-ink/10 bg-cream p-6"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-ink">
                <d.icon className="h-5 w-5 text-sun" />
              </span>
              <div>
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ink/50">
                  {d.label}
                </p>
                <p className="mt-1 font-display text-base font-bold leading-snug sm:text-lg">
                  {d.value}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
